import React, { useState, createContext } from "react";
import { config as defaultConfig } from "./defaultDataConfig";
import {
  cuestionsByGroupInOrderAsc,
  getAnswersFromInitialValues,
  sortGroups
} from "../utils/utils";

export const StepperContext = createContext();
export const EWContext = createContext();
export const AccountVerificationProvider = (props) => {
  const {
    groups,
    questions,
    customErrors,
    version,
    answers
  } = props.config;

  const groupsSorted = sortGroups(groups);
  const steps = groupsSorted.map(group => group.label);
  const stepperDefaultValues = {
    steps,
    activeStep: {
      index: 0,
      id: groupsSorted[0]?.id || "validate",
      label: steps[0] || ""
    },
  };

  const questionsObj = groupsSorted.reduce((objQuestion, group) => {
    objQuestion[group.id] = cuestionsByGroupInOrderAsc(questions, group.id)
    return objQuestion;
  }, {});

  const answersObj = groupsSorted.reduce((objAnswer, group) => {
    objAnswer[group.id] = getAnswersFromInitialValues(questionsObj[group.id], version, answers?.[group.id]);
    return objAnswer;
  }, {});

  const eligibilityData = {
    ...props.config,
    questions: questionsObj,
    answers: answersObj,
    groups: groupsSorted,
    sections: {},
    sectionsAnswers: {},
    selectedDocumentsValues: [],
    savingsDataResponse: {},
    skeduloJobData: {},
    customErrors: customErrors || defaultConfig.customErrors,
    recaptchaVerification: false,
    addressVerification: false,
    accountVerificationUtility: false,
    submitAttempts: 0,
    eligibilityError: {
      message: "",
      genericMessage: "",
      error: false,
      labelButton: "Back",
    },
    customerValidation: [],
    callSavingsService: {
      flag: false,
      answers: "",
      ahriNumberAnswer: null
    },
  };

  const [stepperState, setStepperState] = useState(stepperDefaultValues);
  const [formState, setFormState] = useState(eligibilityData);
  return (
    <StepperContext.Provider value={[stepperState, setStepperState]}>
      <EWContext.Provider value={[formState, setFormState]}>
        {props.children}
      </EWContext.Provider>
    </StepperContext.Provider>
  );
};
